import React, { FunctionComponent } from 'react';
import { FormControl, FormHelperText, Grid, TextField } from '@material-ui/core';

type FieldDefaultWagerPercentProps = {
    error: boolean;
    onChange: (object: any) => void;
    value: number;
    formHelperText: string;
    className: string;
};

function cmp(prev: FieldDefaultWagerPercentProps, cur: FieldDefaultWagerPercentProps): boolean {
    return prev.error === cur.error && prev.formHelperText === cur.formHelperText && prev.value === cur.value;
}

const FieldDefaultWagerPercent: FunctionComponent<FieldDefaultWagerPercentProps> = React.memo(({ error, onChange, value, formHelperText, className }) => {
    return <Grid item xs={12} sm={3}>
        <FormControl error={error} fullWidth size="small">
            <TextField className={className} type="search" name="default_wager_percent" value={value} onChange={onChange} size="small" />
            <FormHelperText> {formHelperText} </FormHelperText>
        </FormControl>
    </Grid>;
}, cmp);

export default FieldDefaultWagerPercent;